/**
 * 动态按顺序加载 js 脚本
 */
const loadedScripts = new Set();  
  
const loadScript = function(url) {  
  if (loadedScripts.has(url)) {  
    return Promise.resolve();  
  }  
  return new Promise((resolve, reject) => {  
    const script = document.createElement('script');  
    script.src = url; 

    script.onload = () => {  
      loadedScripts.add(url);  
      resolve(script);  
    };

    script.onerror = () => reject(new Error(`Script load error for ${url}`)); 
    document.head.appendChild(script);  
  });  
}; 

export async function loadScriptsInOrder(urls) {  
  for (const url of urls) {  
    await loadScript(url); 
  }  
}  


// WEBPACK FOOTER //
// ./src/utils/loadScript.js